// Single home for the OpenFreeMap basemap style URLs so every map picks the
// style matching the active theme from one place.
import type { ResolvedTheme } from "../lib/theme";

export const BASEMAP_STYLES: Record<ResolvedTheme, string> = {
  light: "https://tiles.openfreemap.org/styles/liberty",
  dark: "https://tiles.openfreemap.org/styles/dark",
};

export function basemapStyle(theme: ResolvedTheme): string {
  return BASEMAP_STYLES[theme];
}
